"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lockedTableData = void 0;
exports.lockedTableData = `query GetLockedTableData(
  $limit: Int
  $after: String
  $lockedTableId: SuiAddress!
) {
  owner(address: $lockedTableId) {
    dynamicFields(first: $limit, after: $after) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        name {
          json
        }
        value {
          __typename
          ... on MoveValue {
            json
          }
        }
      }
    }
  }
}
`;
//# sourceMappingURL=lockedTableData.js.map